import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-17" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-18" data-mp="avd0itzoq0d6">
          <span aria-hidden="true" data-id="element-19" data-mp="fsv9ulhm6hlp">🎁 </span>5 bonus exclusifs
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-20" data-mp="1tvk1aid7wny">
          Valeur totale{' '}
          <span className="font-bold text-amber-600 line-through" data-id="element-21" data-mp="5vqhg3x6dpwg">76 €</span> —
          inclus <span className="font-bold text-brand" data-id="element-22" data-mp="3o1lfsst9nnjz">GRATUITEMENT</span>
        </p>

        <ol className="mt-9 space-y-4" data-id="element-23" data-mp="3o3pu84osk4yi">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-5 shadow-[0_1px_3px_rgba(20,17,15,0.06)]" data-id="element-24" data-mp="3t0yd67hrkd0t" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-25" data-mp="1r80e3txe8o7f">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-20 w-16 shrink-0 rounded-md object-cover shadow-[0_2px_8px_rgba(20,17,15,0.12)]" data-id="element-26" data-mp="3dea994tuhm9s" />
              <div className="min-w-0 flex-1" data-id="element-27" data-mp="3n6g2ehvu29qk">
                <h3 className="font-display text-sm font-bold leading-snug text-ink" data-id="element-28" data-mp="2zfkf9y2bo2pn">
                  {bonus.title}
                </h3>
                <p className="mt-0.5 text-[11px] leading-snug text-ink/55" data-id="element-29" data-mp="2uhiwzfcq07f8">
                  {bonus.subtitle}
                </p>
              </div>
              <p className="shrink-0 text-right text-[11px] font-bold leading-tight" data-id="element-30" data-mp="38dw2rr7w6kdv">
                <span className="block text-amber-600 line-through" data-id="element-31" data-mp="33fumtf5rj16m">
                  {bonus.was}
                </span>
                <span className="block text-brand" data-id="element-32" data-mp="iqyhubzbel0a">OFFERT</span>
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}